import { Accordion, Tabs } from '@frontend/design-system';

const mockData = [
  {
    title: 'Onboarding',
    sub: ['Audit', 'Kimberlee’s Team', 'Testing'],
  },
  {
    title: 'Security',
    sub: ['Audit', 'Kimberlee’s Team', 'Testing'],
  },
];

export const DeptFilters = () => {
  return (
    <>
      {mockData.map((data) => {
        return (
          <Accordion variant='hybrid' key={data.title}>
            <Accordion.Item value={data.title}>
              <Accordion.Header>{data.title}</Accordion.Header>
              <Accordion.Body>
                <Tabs initialTab={data.title}>
                  <Tabs.Bar fullWidth={true}>
                    <Tabs.Tab id='Audit'>Audit</Tabs.Tab>
                    <Tabs.Tab id='Kimberlees Team'>Kimberlee's Team</Tabs.Tab>
                    <Tabs.Tab id='Testing'>Testing</Tabs.Tab>
                  </Tabs.Bar>
                  <Tabs.Panel controller='Audit'>
                    <></>
                  </Tabs.Panel>
                </Tabs>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        );
      })}
    </>
  );
};
